export default "__VITE_ASSET__c9d90a55__"